export const css = {
    root: 'affUYMaU',
    domain_carousels: '_2fZXIOnl',
    studyplan_carousel: '_2U57LlSr',
    msp_desc: '_3uz7rEFp',
    studyplan_instructions: '_3NeoGnu0',
    linear: 'rmaaXeRF',
    bar: '_2VlCStOx',
    ' _key': 'explore-view/carousel-view'
};
export default css;
